// JS realiza cambio de variantes de productos Ej. variantes de productos vista PRODUCTO o vista rapida PRODUCTOS

$(document).ready(function(){
    // variantes
    let variant = ''

    // acciones
    $('body').on('click', '.js-switch__action', function(event) {
        setTimeout(() => {
            switchClick($(this))
            switchContent($(this))
        }, 200)
    })

    $('body').on('change', '.js-switch__action-select', function(event) {
        setTimeout(() => {
            switchClickSelect($(this))
            switchContent($(this))
        }, 200)
    })

    // funciones
    function switchClick(action) {
        variant = ''
        option1 = ''
        option2 = ''
        option3 = ''

        $('.js-switch__action').each( function (){
            if ( action.data('switch__id') == $(this).data('switch__id') ) {

                if ( $(this).hasClass('is-switch') ) {
                    
                    if ( $(this).data('switch__position') == 1) {
                        option1 = $(this).data('switch__value')
                    }
                    if ( $(this).data('switch__position') == 2) {
                        option2 = ` / ${ $(this).data('switch__value') }`
                    }
                    if ( $(this).data('switch__position') == 3) {
                        option3 = ` / ${ $(this).data('switch__value') }`
                    }
                }

            }
        })

        variant += `${option1}${option2}${option3}`
    }

    function switchClickSelect(action) {
        variant = ''
        option1 = ''
        option2 = ''
        option3 = ''

        $('.js-switch__action-select').each( function (){
            if ( action.data('switch__id') == $(this).data('switch__id') ) {
                    
                if ( $(this).data('switch__position') == 1) {
                    option1 = $(this).val()
                }
                if ( $(this).data('switch__position') == 2) {
                    option2 = ` / ${ $(this).val() }`
                }
                if ( $(this).data('switch__position') == 3) {
                    option3 = ` / ${ $(this).val() }`
                }

            }
        })

        variant += `${option1}${option2}${option3}`
    }

    function switchContent(action) {
        let check = false

        switchCleanContent(action)

        // $('.js-switch__content').each( function (){
        //     if ( action.data('switch__id') == $(this).data('switch__id') ) {
        //         if (variant == $(this).data('switch__value') ) {
        //             switchCleanContent(action)
        //         }
        //     }
        // })

        $('.js-switch__content').each( function (){
            if ( action.data('switch__id') == $(this).data('switch__id') ) {
                if (variant == $(this).data('switch__value') ) {
                    check = true
                    $(this).addClass( $(this).data('switch__active') )
                }
            }
        })

        switchAdds(action, check)
    }

    function switchCleanContent(action) {
        $('.js-switch__content').each( function (){
            if ( action.data('switch__id') == $(this).data('switch__id') ) {
                $(this).removeClass( $(this).data('switch__active') )
            }
        })
    }

    function switchAdds(action, check) {
        $('.js-switch__add').each( function (){
            if ( action.data('switch__id') == $(this).data('switch__id') ) {
                if (check) {
                    if ( $(this).data('switch__view') ) {
                        $(this).addClass( $(this).data('switch__active') )
                    }else{
                        $(this).removeClass( $(this).data('switch__active') )
                    }
                }else{
                    if ( $(this).data('switch__view') ) {
                        $(this).removeClass( $(this).data('switch__active') )
                    }else{
                        $(this).addClass( $(this).data('switch__active') )
                    }
                }
            }
        })
    }

})
